import type { FC } from 'react';
import React from 'react';

interface Props {
  functionCall: string | undefined;
}
export const LoadingDots: FC<Props> = (props) => {
  if (!props.functionCall) return null;
  return (
    <div className="flex items-center justify-center">
      <div className="flex items-center">
        <span className="text-xs mr-2">{props.functionCall}</span>
        <div className="flex space-x-1">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="w-2 h-2 bg-gray-700 rounded-full"
              style={{
                animation: `blink 1.5s infinite ${i * 0.3}s`,
                opacity: 0.2,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
